import React, { useState } from 'react'
import styles from './input.module.scss'


const types = {
  text: 'text',
  email: 'email',
  number: 'number',
  time: 'time',
  date: 'date',
  password: 'password'
}

interface IProps {
  name: string
  label?: string
  iconLeft?: any
  IconRight?: string
  placeholder?: string
  type: keyof typeof types
  handleInputChange?: any
  handleValidation?: any
  min?: string | number
  legalText?: string
  value?: any
  error?: boolean
  currency?: string
  readOnly?: boolean
  searchIcon?: boolean
  modifiers?: string
  resetError?: any
  countryCode?: string
  isAllowOnlyDigits?: boolean
}

const Input = React.memo(function Input({ type, handleInputChange, isAllowOnlyDigits, ...props }: IProps) {
  const [focused, setFocused] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const handleChange = (value: string) => {
    if (isAllowOnlyDigits ? /^[0-9]*$/.test(value) : true) {  
      handleInputChange()(value);
      setInputValue(value);
    }
  }

  const handleBlur = () => {
    if (props.handleValidation && inputValue) {
      props.handleValidation()(inputValue)
    }
    setFocused(false)
  }

  const handleFocus = () => {
    setFocused(true)
    if (props.resetError) {
      props.resetError()
    }
  }

  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      {props.label && <label htmlFor={props.name} className={styles.inputLabel}>{props.label}</label>}
      <div className={`${styles.inputWrapper} ${props.error ? styles.errorState : ''} ${focused ? styles.inputFocused : ''}`}>
        {props.iconLeft && <span className={styles.inputIcon}>
          {props.iconLeft}
        </span>
        }
        {props.countryCode && <span className={styles.countryCode}>{props.countryCode}</span>}
        <input
          id={props.name}
          className={props.searchIcon ? styles.searchInput : styles.input}
          placeholder={props.placeholder}
          type={type}
          readOnly={props.readOnly}
          autoComplete={'off'}
          disabled={props.readOnly}
          value={props.value || props.value === '' ? props.value : inputValue}
          min={props.min}
          onChange={(e) => handleChange(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {props.IconRight && <div className={styles.iconRight}>
          <img src={props.IconRight} />
        </div>}
        {props.currency && <span className={styles.currency}>{props.currency}</span>}
      </div>
      {props.legalText && <p className={styles.legalText}>{props.legalText}</p>}
    </div>
  )
})

export default Input
